import { makeStyles } from '@mui/styles';

export const useStyles = makeStyles((theme) => ({
  root: {},
  title: {
    color: '#1a334d',
    marginBottom: 0,
  },
  btn: {
    color: '#006cfc',
    borderRadius: '4px',
    boxShadow: '0 1px 1px 0 rgba(0, 0, 0, 0.07)',
    border: 'solid 2px #006cfc',
  },
  wrapIcon: {
    verticalAlign: 'middle',
    display: 'inline-flex',
  },
  tabPanel: {
    paddingTop: theme.spacing(2),
    paddingBottom: theme.spacing(2),
    paddingInlineStart: 0,
    paddingInlineEnd: 0,
  },
  containButton: {
    '& > *': {
      margin: `5px 10px`,
    },
  },
  buttonProgress: {
    color: theme.palette.primary.main,
    position: 'absolute',
    top: '50%',
    left: '50%',
    marginTop: -8,
    marginLeft: -12,
  },
  headerContainer: {
    justifyContent: 'flex-end',
    [theme.breakpoints.down('sm')]: {
      alignItems: 'flex-start',
      flexDirection: 'column',
    },
  },
  submitContainer: {
    paddingTop: theme.spacing(2),
    borderTop: `1px solid ${theme.palette.grey[300]}`,
  },
}));